<template>
  <validation-observer ref="form" novalidate>
    <div class="row">
      <div class="col-12">
        <section-title
          container-class="tag-badge-main-info mt-4 mb-4"
          content="VIII. Valores"
          icon="fas fa-clipboard-list-check"
        />
        <label class="text-muted" style="font-size: 14px">
          Según la O*NET los valores predominantes en esta ocupación son:
        </label>

        <validation-provider
          v-if="!isReadOnly"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-text-area
            v-model="model.selfReliance"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            custom-error-msg="Campo requerido"
            :disabled="isReadOnly"
            :error="errors[0]"
            label="Independencia:"
            :maxlength="5000"
            show-char-count
          />
        </validation-provider>
        <div v-else class="d-flex flex-column">
          <label class="text-muted" style="font-size: 14px">
            Independencia:
          </label>
          <span>{{ model.selfReliance }}</span>
        </div>

        <validation-provider
          v-if="!isReadOnly"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-text-area
            v-model="model.achievements"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            custom-error-msg="Campo requerido"
            :disabled="isReadOnly"
            :error="errors[0]"
            label="Logros:"
            :maxlength="5000"
            show-char-count
          />
        </validation-provider>
        <div v-else class="d-flex flex-column">
          <label class="text-muted" style="font-size: 14px">
            Logros:
          </label>
          <span>{{ model.achievements }}</span>
        </div>

        <validation-provider
          v-if="!isReadOnly"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-text-area
            v-model="model.workingConditionsConclusions"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            custom-error-msg="Campo requerido"
            :disabled="isReadOnly"
            :error="errors[0]"
            label="Condiciones de trabajo Conclusiones:"
            :maxlength="5000"
            show-char-count
          />
        </validation-provider>
        <div v-else class="d-flex flex-column">
          <label class="text-muted" style="font-size: 14px">
            Condiciones de trabajo Conclusiones:
          </label>
          <span>{{ model.workingConditionsConclusions }}</span>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
//mixins
import alertMixin from '@/mixins/alert.mixin.js';

//utils
import { copy } from '@/utils/objUtils';

//components
import SectionTitle from '@/shared/components/SectionTitle.vue';
import CustomTextArea from 'CustomTextArea';

//services
import { getEight } from '@/modules/vocational-evaluation/api.js';

export default {
  name: 'VocationalEducationPartEight',
  components: {
    SectionTitle,
    CustomTextArea,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: [Number, String],
      default: () => null,
    },
    appointmentId: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    initialModel: {
      type: Object,
      required: false,
      default: () => null,
    },
    keepUpdates: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    filled() {
      return this.initialModel?.filled ?? false;
    },
  },
  beforeDestroy() {
    this.$emit('update:initialModel', this.model);
  },
  async mounted() {
    this.$emit('update:disabled', true);
    await this.get();
    this.$emit('update:disabled', false);
  },
  methods: {
    setModelFrom(value) {
      const data = copy(value);
      this.model = data;
      this.$emit('update:initialModel', data);
    },
    async get() {
      if (this.keepUpdates && this.filled) {
        this.setModelFrom(this.initialModel);
        return;
      }

      if (!this.appointmentId) return;
      const { data } = await getEight({
        id: this.id,
        appointmentId: this.appointmentId,
      });
      this.setModelFrom({ ...data, filled: true });
    },
    async validate() {
      return await this.$refs.form.validate();
    },
  },
};
</script>
<style scoped>
.collapse-item ::v-deep .card-header {
  padding: 0.75rem 1rem !important;
}

.collapse-item ::v-deep .tag-badge-pei {
  background: none;
}

.collapse-item.section ::v-deep .shadow2 {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: none !important;
  background-color: #f7f7f7;
}
.collapse-item.section ::v-deep .card-header {
  border-radius: 0.25rem !important;
  border-bottom: 2px solid #e6e6e6;
}
.collapse-item.section ::v-deep .card-header .title-number-box {
  background-color: #2db782;
}

.collapse-item.invalid.section {
  border: 1px solid #ff0018 !important;
}
.collapse-item.invalid.section ::v-deep .card-header .title-number-box {
  background-color: #ff5b5c !important;
}
.collapse-item ::v-deep .color-warning {
  color: #ff5b5c !important;
}
::v-deep
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #3f5b60 !important;
  border-color: #3f5b60 !important;
}
</style>
